import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Announcements, AnnouncementsUsersTracking } from '@store/what-is-new/what-is-new.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhatIsNewService {
  constructor(private readonly http: HttpClient) {}

  public getAllAnnouncements(): Observable<Announcements[]> {
    return this.http.get<Announcements[]>('/api/getAllAnnouncements');
  }

  public getAllAnnouncementsByContentId(contentId: string): Observable<Announcements[]> {
    return this.http.get<Announcements[]>(`/api/getAnnouncementByContentId`, {
      params: {
        contentId
      }
    });
  }

  public getAllEnabledAnnouncements(): Observable<Announcements[]> {
    return this.http.get<Announcements[]>('/api/getAllEnabledAnnouncements');
  }

  public getAllUnreadAnnouncements(usersTracking: AnnouncementsUsersTracking): Observable<Announcements[]> {
    return this.http.get<Announcements[]>(`/api/getAllUnreadAnnouncements`, {
      params: {
        groupName: usersTracking.groupName,
        userId: usersTracking.userId
      }
    });
  }

  public getAllReadAnnouncements(usersTracking: AnnouncementsUsersTracking): Observable<Announcements[]> {
    return this.http.get<Announcements[]>(`/api/getAllReadAnnouncements`, {
      params: {
        groupName: usersTracking.groupName,
        userId: usersTracking.userId
      }
    });
  }

  public markAnnouncementRead(usersTracking: AnnouncementsUsersTracking): Observable<boolean> {
    return this.http.post<boolean>(`/api/markAnnouncementRead`, {
      groupName: usersTracking.groupName,
      userId: usersTracking.userId,
      contentId: usersTracking.contentId
    });
  }
}
